import _ from 'lodash';

import AgentProfile from 'models/agent_profile';
import EditableUser from 'models/editable_user';
import Err from 'models/err';
import User from 'models/user';

export default class PutUserBase {
  constructor(context) {
    this.context = context;
  }

  run(editableUserAttrs) {
    if (this.context.stores.userEditor.isPending()) {
      return;
    }

    let { id, email, name, roleIds, stationId } = editableUserAttrs;

    let validationErrors = this.getValidationErrors({ email, id, name, roleIds, stationId });
    if (validationErrors.length) {
      this.context.stores.userEditor.setErrors(validationErrors);
      return;
    }

    let userEditor = this.context.stores.userEditor.get();
    let editableUser = new EditableUser(_.assign({}, userEditor.toJs(), editableUserAttrs));
    this.context.stores.userEditor.setPending(editableUser);
    this.runAction(editableUser);
  }

  getValidationErrors({ email, id, name, roleIds, stationId }) {
    let userErrors = User.getValidationErrors({ username: email, roleIds });

    let user = this.context.stores.users.findBy({ username: email });
    if (user) {
      let agentProfile = this.context.stores.agentProfiles.findBy({ id: user.id });
      if (agentProfile && user.id !== id) {
        // set error only if user and agent profile exists
        userErrors.push(new Err({ code: Err.Code.TAKEN, attr: 'username', detail: 'Email is already taken' }));
      }
    }

    let agentProfileErrors = AgentProfile.getValidationErrors({ name });
    if (stationId) {
      let agentProfile = this.context.stores.agentProfiles.findBy({ voiceConfiguration: { stationId } });
      if (agentProfile && agentProfile.id !== id) {
        agentProfileErrors.push(
          new Err({ code: Err.Code.TAKEN, attr: 'stationId', detail: 'Station ID is already taken' })
        );
      }
    }

    return userErrors.concat(agentProfileErrors);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/put_user_base.js